import { hotKeywords, liveStats } from "@/mocks/digData";

export default function Hero() {
  return (
    <section id="home" className="relative w-full min-h-[560px] md:min-h-[680px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20editorial%20poster%20of%20a%20glowing%20stage%20with%20scattered%20melon%20slices%20and%20floating%20news%20headline%20fragments%2C%20deep%20warm%20brown%20and%20coral%20toned%20night%20scene%2C%20dramatic%20spotlight%20beams%2C%20moody%20abstract%20graphic%20illustration%2C%20high%20contrast%2C%20cinematic&width=1800&height=1000&seq=guatian-hero-01&orientation=landscape"
          alt="网爆吃瓜连续剧追踪站首屏背景，深夜舞台与热点碎片意象"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/65 to-foreground-950/85" />
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 pt-28 md:pt-40 pb-16 md:pb-20">
        <div className="animate-rise max-w-3xl">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-primary-300/50 bg-primary-500/20 text-primary-100 text-xs md:text-sm">
            <span className="w-2 h-2 rounded-full bg-primary-400 animate-pulse-dot" />
            滚动跟进中 · 最近更新 09-10 22:14
          </span>

          <h1 className="mt-6 font-heading text-4xl md:text-6xl font-black text-background-50 leading-tight text-balance">
            网爆吃瓜连续剧
            <span className="block mt-2 text-primary-300">一页看懂整条剧情线</span>
          </h1>

          <p className="mt-6 text-base md:text-lg text-background-200 leading-relaxed max-w-2xl">
            把零散的热议整理成有始有终的连续剧：跟进后续反转、最新进展、当事人发声与官方回应。
            新瓜出现第一时间同步，先对齐事实，再讨论观点。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <a
              href="#timeline"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-live-line text-lg" />
              查看最新进展
            </a>
            <a
              href="#rank"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-50/40 text-background-50 font-medium whitespace-nowrap hover:bg-background-50/10 transition-colors cursor-pointer"
            >
              <i className="ri-fire-line text-lg" />
              打开新瓜榜
            </a>
          </div>
        </div>

        <div className="mt-12 md:mt-16 grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5">
          {liveStats.map((stat) => (
            <div
              key={stat.id}
              className="rounded-lg border border-background-50/15 bg-background-950/40 backdrop-blur-sm p-4 md:p-5"
            >
              <div className="flex items-center gap-2 text-background-200 text-xs md:text-sm">
                <span className="w-6 h-6 flex items-center justify-center">
                  <i className={`${stat.icon} text-secondary-300 text-base`} />
                </span>
                {stat.label}
              </div>
              <div className="mt-2 flex items-end gap-1">
                <span className="font-heading text-2xl md:text-3xl font-black text-background-50">
                  {stat.value}
                </span>
                <span className="text-background-300 text-sm pb-0.5">{stat.unit}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="relative z-10 w-full border-t border-background-50/15 bg-foreground-950/70 py-3 overflow-hidden">
        <div className="flex items-center gap-4 px-4 md:px-8">
          <span className="shrink-0 inline-flex items-center gap-1.5 text-secondary-300 text-xs md:text-sm font-medium">
            <i className="ri-flashlight-fill" />
            热词速览
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="flex items-center gap-6 animate-marquee whitespace-nowrap w-max">
              {[...hotKeywords, ...hotKeywords].map((word, index) => (
                <span key={`${word}-${index}`} className="text-background-200 text-xs md:text-sm">
                  #{word}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}